document.addEventListener("DOMContentLoaded", () => {
  const bundleSection = document.querySelector(".pick-any-three");

  if (!bundleSection) return;

  const maxItems = Number(bundleSection.dataset.maxItems || 3);

  const selectedVariants = [];
  const productCards = bundleSection.querySelectorAll(".bundle-card");
  const countElement = bundleSection.querySelector("[data-selected-count]");
  const summaryElement = bundleSection.querySelector("[data-selected-summary]");
  const addBundleButton = bundleSection.querySelector("[data-add-bundle]");
  function updateBundleHeaderHeight() {
  const possibleHeaders = [
    document.querySelector(".header-wrapper"),
    document.querySelector("#shopify-section-header"),
    document.querySelector("sticky-header"),
    document.querySelector("header")
  ];

  const siteHeader = possibleHeaders.find((header) => header);

  if (!siteHeader) {
    bundleSection.style.setProperty("--bundle-header-height", "80px");
    return;
  }

  const headerHeight = Math.ceil(siteHeader.getBoundingClientRect().height);

  bundleSection.style.setProperty(
    "--bundle-header-height",
    `${headerHeight + 8}px`
  );
}

updateBundleHeaderHeight();

window.addEventListener("resize", updateBundleHeaderHeight);
window.addEventListener("load", updateBundleHeaderHeight);
  function updateBundleHeaderHeight() {
  const possibleHeaders = [
    document.querySelector(".header-wrapper"),
    document.querySelector("#shopify-section-header"),
    document.querySelector("sticky-header"),
    document.querySelector("header")
  ];

  const siteHeader = possibleHeaders.find((header) => header);

  if (!siteHeader) {
    bundleSection.style.setProperty("--bundle-header-height", "80px");
    return;
  }

  const headerHeight = Math.ceil(siteHeader.getBoundingClientRect().height);

  bundleSection.style.setProperty(
    "--bundle-header-height",
    `${headerHeight + 8}px`
  );
}

updateBundleHeaderHeight();

window.addEventListener("resize", updateBundleHeaderHeight);
window.addEventListener("load", updateBundleHeaderHeight);

 function updateBundleUI() {
 const count = selectedVariants.length;
  /* Update 0 / 3 selected */
  countElement.textContent = count;

  /* Update the 3-step progress cards */
  const steps = bundleSection.querySelectorAll(".pick-any-three__steps .step");

 steps.forEach((step) => {
  step.classList.remove("active", "complete");
});

const stepLines = bundleSection.querySelectorAll(".step-line");

stepLines.forEach((line) => {
  line.classList.remove("complete");
});

  /* Update customer guidance message + CTA text */
  if (count === 0) {
  summaryElement.textContent = "Pick your first product to get started";
  addBundleButton.textContent = "Choose 3 Products";

  steps[0]?.classList.add("active");

} else if (count === 1) {
  summaryElement.textContent = "Great choice! Add 2 more products";
  addBundleButton.textContent = "Add 2 More Products";

  steps[0]?.classList.add("complete");
  steps[1]?.classList.add("active");

  stepLines[0]?.classList.add("complete");

} else if (count === 2) {
  summaryElement.textContent = "Almost there! Add 1 more product";
  addBundleButton.textContent = "Add 1 More Product";

  steps[0]?.classList.add("complete");
  steps[1]?.classList.add("active");

  stepLines[0]?.classList.add("complete");

} else {
  summaryElement.textContent = "Your Everyday Box is ready!";
  addBundleButton.textContent = "Add Bundle to Cart";

  steps[0]?.classList.add("complete");
  steps[1]?.classList.add("complete");
  steps[2]?.classList.add("active");

  stepLines[0]?.classList.add("complete");
  stepLines[1]?.classList.add("complete");
}

  /* Cart button works only after exactly 3 products are selected */
  addBundleButton.disabled = count !== maxItems;

  /* Update every product card */
  productCards.forEach((card) => {
    const variantId = card.dataset.variantId;
    const button = card.querySelector("[data-bundle-select]");
    const isSelected = selectedVariants.includes(variantId);
    const isSoldOut = card.querySelector(".bundle-card__soldout");

    card.classList.toggle("is-selected", isSelected);

    if (isSelected) {
      button.textContent = "Remove";
    } else {
      button.textContent = "Add to Box";
    }

    /*
      Disable unselected products only after 3 products are selected.
      Selected products always remain clickable so customers can remove them.
    */
    if (isSoldOut) {
      button.disabled = true;
    } else if (!isSelected && count >= maxItems) {
      button.disabled = true;
    } else {
      button.disabled = false;
    }
  });
}

  productCards.forEach((card) => {
    const button = card.querySelector("[data-bundle-select]");

    button.addEventListener("click", () => {
      const variantId = card.dataset.variantId;
      const selectedIndex = selectedVariants.indexOf(variantId);

      if (selectedIndex > -1) {
        selectedVariants.splice(selectedIndex, 1);
      } else {
        if (selectedVariants.length >= maxItems) return;
        selectedVariants.push(variantId);
      }

      updateBundleUI();
    });
  });

  addBundleButton.addEventListener("click", async () => {
    if (selectedVariants.length !== maxItems) return;

    addBundleButton.disabled = true;
    addBundleButton.textContent = "Adding...";

    try {
      const items = selectedVariants.map((variantId) => ({
        id: Number(variantId),
        quantity: 1,
        properties: {
          "_bundle_offer": "Pick Any 3 @ ₹1499",
          "_bundle_group": `yes-pick-any-3-${Date.now()}`
        }
      }));

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error("Could not add products to cart.");
      }

      window.location.href = `${window.Shopify.routes.root}cart`;
    } catch (error) {
      console.error(error);
      addBundleButton.disabled = false;
      addBundleButton.textContent = "Try Again";
      alert("Something went wrong. Please try again.");
    }
  });

  updateBundleUI();
});